import React from "react";
import Footer from "../Footer";
import AButton from "../../../../views/pages/manage/common/form-fields-mui/AButton";
import { useWizard } from "../../../../components/wizard/WizardContext";

const SelectStudentFooter = ({ validate = () => {} }) => {
  const { values } = useWizard();
  const { selectedStudent } = values;
  const selectedStudentApplicationId = selectedStudent?.applicationId || "";

  return (
    <Footer>
      {selectedStudentApplicationId ? (
        "1 Student selected"
      ) : (
        <div>Select student</div>
      )}
      <AButton
        disabled={!selectedStudentApplicationId}
        onClick={() => validate(selectedStudent)}
        className="button_remove_left_margin"
        variant="primary_filled"
      >
        Proceed next
      </AButton>
    </Footer>
  );
};

export default SelectStudentFooter;
